import React, { useEffect, useState, useCallback } from 'react';
import {
  Container,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { APIgetAdminOnlineUsers } from '../../api/Admin';

import AdminPanelOnlineUserList from '../../components/AdminPanel/OnlineUserList';

import Loading from '../../components/Loading';
import NothingFound from '../../components/NothingFound';

const AdminPanelOnlineUsers = () => {
  const [online, setOnline] = useState(null);
  const [onlineLoading, setOnlineLoading] = useState(true);

  const intl = useIntl();

  const fetchOnline = useCallback(() => {
    APIgetAdminOnlineUsers({ users: true }).then((response) => {
      setOnline(response.data);
      setOnlineLoading(false);
    });
  }, []);

  useEffect(() => {
    fetchOnline();
  }, [fetchOnline]);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchOnline();
    }, 10 * 1000);
    return () => clearInterval(interval);
  }, [fetchOnline]);

  return (
    <div className="main-content split-content page-online-users">
      <div className="split-content-wrapper">
        <Container fluid>
          <header className="page-header">
            <h2 className="page-title">
              <i className="far fa-users" />
              {intl.formatMessage({ defaultMessage: 'Online Users' })}
            </h2>
            <div className="header-actions">
              <div className="items-displaying">
                {!onlineLoading && (
                  <span>
                    {intl.formatMessage(
                      { defaultMessage: '{usersCount} {usersCount, plural, one {user} other {users}} online' },
                      {
                        usersCount: online.users_count,
                      },
                    )}
                  </span>
                )}
              </div>
            </div>
          </header>
          <div className="content-wrapper admin-panel-wrapper admin-online-users-wrapper">
            {onlineLoading ? (
              <Loading />
            ) : (
              <>
                {online.users.length > 0 ? (
                  <AdminPanelOnlineUserList
                    users={online.users}
                  />
                ) : (
                  <NothingFound text={intl.formatMessage({ defaultMessage: 'No users online' })} />
                )}
              </>
            )}
          </div>
        </Container>
      </div>
    </div>
  );
};

export default AdminPanelOnlineUsers;
